<template>
  <v-layout justify-center id="send-reset-password">
    <v-flex xs12 sm6 md3>
      <v-img
        class="mb-5 mt-5"
        src="/img/plas.png"
        contain
        :height="128"
      />
      <v-card>
        <v-toolbar color="primary" class="text-xs-center">
          <v-toolbar-title class="text-uppercase">
            {{ $t('RESET_PASSWORD_REQUEST') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <ValidationObserver
            ref="form"
            tag="form"
            @submit.prevent="sendResetPassword"
          >
            <ValidationProvider
                rules="required"
                vid="email"
                :name="$t('fields.email').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model="email"
                prepend-icon="email"
                name="email"
                type="text"
                autocomplete="off"
                :label="$t('fields.email')"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions
          class="pl-3 pr-3 pt-1 pb-2"
        >
          <v-layout justify-center>
            <v-btn
              color="primary"
              type="submit"
              @click="sendResetPassword()"
              :loading="loading"
              :disabled="loading"
            >{{ $t('RESET_PASSWORD') }}</v-btn>
          </v-layout>
        </v-card-actions>
        <v-card-actions
          class="pl-3 pr-3 pt-1 pb-3"
        >
          <router-link
            :to="{ name: 'login' }"
          >
            {{ $t("BACK_TO_LOGIN") }}
          </router-link>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex';
  import { passwordService } from '../utils/services/password.service';

  export default {
    name: 'SendResetPassword',
    data() {
      return {
        email: null,
        loading: false,
      };
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      async sendResetPassword() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.loading = true;
            passwordService.request(this.email).then(() => {
              this.showToast({ type: 'success', message: this.$t('RESET_PASSWORD_EMAIL_SENT') });
              this.$router.push({ name: 'login' });
            }, error => {
              this.handleError(error, this.errors);
            }).then(() => {
              this.loading = false;
            });
        }
      },
    },
  };
</script>

<style scoped>

</style>
